// Auto-generated by the generator
// Don't manually edit this file

// @flow

import type {Action} from '../../types'
import type {GbiprojectState} from '../types'

import {setLoadingReducer} from './setLoading'
import {setErrorReducer} from './setError'
import {initialState} from './initialState'

export const gbiProjectReducer = (state: GbiprojectState = initialState, action: Action<any>): GbiprojectState => {
  switch (action.type) {
    case 'gbiProject/SET_LOADING':
      return setLoadingReducer(state, action)
    case 'gbiProject/SET_ERROR':
      return setErrorReducer(state, action)
    default:
      return state
  }
}
